(function (window, document) {
  'use strict';

  var GA_MEASUREMENT_ID = 'G-BQ1CG4ZHFB';
  var BRIDGE_FLAG = '__openxpromoGa4BridgeInstalled';
  if (window[BRIDGE_FLAG]) return;
  window[BRIDGE_FLAG] = true;
  var EVENT_NAMES = [
    'begin_rfq',
    'add_to_quote',
    'remove_from_quote',
    'rfq_submit_attempt',
    'generate_lead'
  ];
  var ALLOWED_PARAMETERS = [
    'form_name',
    'inquiry_id',
    'quote_item_count',
    'product_handle',
    'add_method',
    'lead_source',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'intent',
    'oppref',
    'oa_ad_account_id',
    'oa_campaign_id',
    'oa_ad_group_id',
    'oa_ad_id'
  ];
  var leadSentThisPage = false;
  var sentLeadIds = {};

  function gtagCommand() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag === 'function') {
      window.gtag.apply(window, arguments);
      return;
    }
    window.dataLayer.push(arguments);
  }

  function cleanString(value, maxLength) {
    var cleaned = String(value || '').trim();
    if (!cleaned) return null;
    if (/[^\s@]+@[^\s@]+\.[^\s@]+/.test(cleaned)) return null;
    if (!/^[A-Za-z0-9._~:=-]+$/.test(cleaned)) return null;
    return cleaned.slice(0, maxLength);
  }

  function cleanParameter(value) {
    if (typeof value === 'number') return isFinite(value) ? value : null;
    if (typeof value === 'boolean') return value;
    if (typeof value !== 'string') return null;
    return cleanString(value, 100);
  }

  function eventParameters(eventName, event) {
    var source = event && event.detail && typeof event.detail === 'object'
      ? event.detail
      : {};
    var parameters = { send_to: GA_MEASUREMENT_ID };

    ALLOWED_PARAMETERS.forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(source, key)) return;
      var value = cleanParameter(source[key]);
      if (value !== null) parameters[key] = value;
    });

    if (eventName === 'generate_lead' && parameters.inquiry_id) {
      parameters.event_id = parameters.inquiry_id;
    }

    return parameters;
  }

  EVENT_NAMES.forEach(function (eventName) {
    window.addEventListener('openxpromo:' + eventName, function (event) {
      // Controlled QA must not become a business lead or consume lead dedupe.
      // Use only the publisher's exact source/medium pair, not campaign names.
      if (eventName === 'generate_lead' && event && event.detail
        && event.detail.utm_source === 'codex_qa' && event.detail.utm_medium === 'qa') return;
      var parameters = eventParameters(eventName, event);
      if (eventName === 'generate_lead') {
        if (leadSentThisPage) return;
        if (parameters.inquiry_id && sentLeadIds[parameters.inquiry_id]) return;
        leadSentThisPage = true;
        if (parameters.inquiry_id) sentLeadIds[parameters.inquiry_id] = true;
      }
      gtagCommand('event', eventName, parameters);
    });
  });

  // The linked Google & YouTube channel is the sole page-view owner and owns
  // the Google tag, consent state, client ID and session ID. This bridge only
  // projects the five RFQ events above. It loads no SDK and sends no config.
  // Do not add a fallback page view while the channel initializes asynchronously.
})(window, document);
